// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router/router.config";
import store from "./store/index";
import VueWechatTitle from "vue-wechat-title";
import "./assets/js/rem.js";

Vue.use(VueWechatTitle);

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import dayjs from "dayjs";
Vue.prototype.dayjs = dayjs;

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

//百度地图开放平台  目前个人认证（王海涛），配额5000次/天 30次/秒
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, { ak: "6GnYx5FTgxlUWa2eF5Qw9bwZ6ruTmxG8" });

import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);

import "babel-polyfill";

import axios from "./http";

//百度统计代码，目前是用的个人（王海涛）
var _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?b3434958a89b46a010951a6e64401983";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  axios,
  components: { App },
  template: "<App/>",
  render: h => h(App),
  /* 这句非常重要，否则预渲染将不会启动 */
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  }
});



// WEBPACK FOOTER //
// ./src/main.js